import categoriesAPI from 'widget/api/categories';

// Mutation 类型
export const SET_CATEGORIES_UI_FLAG = 'SET_CATEGORIES_UI_FLAG';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
export const SET_CATEGORY_DETAILS = 'SET_CATEGORY_DETAILS';
export const SET_RELATED_CATEGORIES = 'SET_RELATED_CATEGORIES';
export const SET_FETCH_ERROR = 'SET_FETCH_ERROR';

// 初始状态
const state = {
  categories: [],
  selectedCategory: null,
  categoryDetails: {},
  relatedCategories: [],
  uiFlags: {
    isFetching: false,
    hasFetched: false,
    isLoadingDetails: false,
    isLoadingRelated: false,
  },
  error: null,
};

// Getters
export const getters = {
  getCategories: $state => $state.categories,
  getSelectedCategory: $state => $state.selectedCategory,
  getCategoryDetails: $state => $state.categoryDetails,
  getRelatedCategories: $state => $state.relatedCategories,
  getCategoriesUIFlags: $state => $state.uiFlags,
  getError: $state => $state.error,
};

// Actions
export const actions = {
  // 获取所有类别
  async fetch({ commit }) {
    commit(SET_CATEGORIES_UI_FLAG, { isFetching: true });
    commit(SET_FETCH_ERROR, null);
    try {
      const response = await categoriesAPI.getCategories();
      commit(SET_CATEGORIES, response.data.payload || []);
    } catch (error) {
      commit(SET_FETCH_ERROR, error.message || '获取类别数据失败');
    } finally {
      commit(SET_CATEGORIES_UI_FLAG, {
        isFetching: false,
        hasFetched: true,
      });
    }
  },

  // 根据渠道ID获取类别
  async fetchByChannelId({ commit }, channelId) {
    commit(SET_CATEGORIES_UI_FLAG, { isFetching: true });
    commit(SET_FETCH_ERROR, null);
    try {
      const response = await categoriesAPI.getCategoriesByChannelId(channelId);
      commit(SET_CATEGORIES, response.data.payload || []);
    } catch (error) {
      commit(SET_FETCH_ERROR, error.message || '通过渠道ID获取类别失败');
    } finally {
      commit(SET_CATEGORIES_UI_FLAG, {
        isFetching: false,
        hasFetched: true,
      });
    }
  },

  // 根据语言获取类别
  async fetchByLocale({ commit }, locale) {
    commit(SET_CATEGORIES_UI_FLAG, { isFetching: true });
    commit(SET_FETCH_ERROR, null);
    try {
      const response = await categoriesAPI.getCategoriesByLocale(locale);
      commit(SET_CATEGORIES, response.data.payload || []);
    } catch (error) {
      commit(SET_FETCH_ERROR, error.message || '获取特定语言类别失败');
    } finally {
      commit(SET_CATEGORIES_UI_FLAG, {
        isFetching: false,
        hasFetched: true,
      });
    }
  },

  // 选择类别
  selectCategory({ commit }, category) {
    commit(SET_SELECTED_CATEGORY, category);
  },

  // 获取类别详情
  async fetchCategoryDetails({ commit }, categoryId) {
    commit(SET_CATEGORIES_UI_FLAG, { isLoadingDetails: true });
    commit(SET_FETCH_ERROR, null);
    try {
      const response = await categoriesAPI.getCategoryDetails(categoryId);
      commit(SET_CATEGORY_DETAILS, response.data.payload || {});
    } catch (error) {
      commit(SET_FETCH_ERROR, error.message || '获取类别详情失败');
    } finally {
      commit(SET_CATEGORIES_UI_FLAG, {
        isLoadingDetails: false,
      });
    }
  },

  // 获取相关类别
  async fetchRelatedCategories({ commit }, categoryId) {
    commit(SET_CATEGORIES_UI_FLAG, { isLoadingRelated: true });
    commit(SET_FETCH_ERROR, null);
    try {
      const response = await categoriesAPI.getRelatedCategories(categoryId);
      commit(SET_RELATED_CATEGORIES, response.data || []);
    } catch (error) {
      commit(SET_FETCH_ERROR, error.message || '获取相关类别失败');
    } finally {
      commit(SET_CATEGORIES_UI_FLAG, {
        isLoadingRelated: false,
      });
    }
  },
};

// Mutations
export const mutations = {
  [SET_CATEGORIES_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [SET_CATEGORIES]($state, data) {
    $state.categories = data;
  },
  [SET_SELECTED_CATEGORY]($state, category) {
    $state.selectedCategory = category;
  },
  [SET_CATEGORY_DETAILS]($state, details) {
    $state.categoryDetails = details;
  },
  [SET_RELATED_CATEGORIES]($state, categories) {
    $state.relatedCategories = categories;
  },
  [SET_FETCH_ERROR]($state, error) {
    $state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
